export default {
  name: 'Other 8 Types of Waste',
  description: 'Lean sets out to reduce and eliminate these operational waste within any industry. The term DOWNTIME is commonly used to remember The 8 Types of Waste',
  completed: false,
  color: '#775DD0',
  banner: 'parallax-light-blue.jpg',
  costs: [
    {
      name: 'Defect Rework',
      description: 'Efforts caused by rework, scrap and incorrect information',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Overproduction',
      description: 'Production that is more than needed or before it is needed',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Waiting',
      description: 'Wasted or idle time waiting for information, product or services within a process',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Non-Utilized Talents and Skills',
      description: 'Underutilizing people\'s talents, skills and knowledge',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Transportation',
      description: 'Unnecessary or multiple movements of information, products and materials',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Inventory',
      description: 'Excessive information, products and materials not being processed or transforming into fit, form or function',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Motion',
      description: 'Unnecessary movements by people (e.g., walking, searching)',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Extra Processing',
      description: 'More work or higher quality than is required by the customer',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
  ]
};